var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpainIcon = function SvgSpainIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#spain-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M0 14c0 1.713.308 3.353.87 4.87L14 20.087l13.13-1.217c.562-1.517.87-3.158.87-4.87a14 14 0 0 0-.87-4.87L14 7.913.87 9.13A14 14 0 0 0 0 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M27.13 9.13C25.15 3.8 20.02 0 14 0S2.85 3.8.871 9.13zM.871 18.87C2.85 24.2 7.981 28 14.001 28c6.019 0 11.15-3.8 13.129-9.13z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "spain-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgSpainIcon;